import type { FormEvent } from 'react'

export const formatCnpjCpfHelper = (v: string): string => {
  const isCpf = v?.length === 11
  let value = v?.replace(/(\D)/g, '')

  if (isCpf) {
    value = value?.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    return value
  }

  value = value?.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    '$1.$2.$3/$4-$5',
  )
  return value
}

export const formatCepHelper = (e: FormEvent<HTMLInputElement>) => {
  let { value } = e.currentTarget
  value = value.replace(/\D/g, '')

  value = value.replace(/(\d{5})(\d{3})/, '$1-$2')

  e.currentTarget.value = value
  return e
}

export const formatCnpjCpfEventHelper = (e: FormEvent<HTMLInputElement>) => {
  let { value } = e.currentTarget
  const isCpf = value.length === 11
  value = value.replace(/\D/g, '')

  if (isCpf) {
    value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
    e.currentTarget.value = value
    return e
  }

  value = value.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    '$1.$2.$3/$4-$5',
  )
  e.currentTarget.value = value
  return e
}

export const formatCnpjCpf = (value: string) => {
  const isCpf = value.length === 11
  value = value.replace(/\D/g, '')

  if (isCpf) {
    value = value.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')

    return value
  }

  value = value.replace(
    /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
    '$1.$2.$3/$4-$5',
  )
  return value
}

export const formatPhoneHelper = (e: FormEvent<HTMLInputElement>) => {
  let { value } = e.currentTarget
  value = value.replace(/(\D)/g, '')

  value = value.replace(/(\d{2})(\d{4,5})(\d{4})/, '($1) $2-$3')
  e.currentTarget.value = value

  return e
}

export const formatCepToFillTheField = (value: string) => {
  let edited = value?.replace(/(\D)/g, '')
  edited = edited?.replace(/^(\d{5})(\d{3})$/, '$1-$2')

  return edited
}

export const formatPhoneToFillTheField = (value: string) => {
  let edited = value?.replace(/(\D)/g, '')
  edited = edited?.replace(/^(\d{2})(\d{4,5})(\d{4})$/, '($1) $2-$3')

  return edited
}
